<template>
  <div style="margin: 0 24px 24px;">
    <div style="margin-bottom: 16px" v-if="showAddBtn">
      <span style="margin-right: 16px;">宠物主人：</span>
      <el-button @click="editUserDialog">创建新客</el-button>
      <el-button @click="selectUser">选择老客</el-button>
    </div>
    <el-descriptions title="客户信息" border :column="2" size="default" v-if="userForm && JSON.stringify(userForm) != '{}'">
      <el-descriptions-item label-class-name="my-label" class-name="my-item" label="主人">{{ userForm.name }}</el-descriptions-item>
      <el-descriptions-item label-class-name="my-label" class-name="my-item" label="性别" >{{ userForm.sex == 1?'男':userForm.sex == 2?'女':'未知' }}</el-descriptions-item>
      <el-descriptions-item label-class-name="my-label" class-name="my-item" label="手机号">{{ userForm.phone }}</el-descriptions-item>
      <el-descriptions-item label-class-name="my-label" class-name="my-item" label="门店">{{ userForm.shopName}}</el-descriptions-item>
      <el-descriptions-item label-class-name="my-label" class-name="my-item" label="描述" :span="2"><span v-if="userForm.userPerfect">{{userForm.userPerfect.userDesc}}</span></el-descriptions-item>
      <el-descriptions-item label-class-name="my-label" class-name="my-item" label="图片" :span="2">
        <el-space wrap>
          <div class="img-box" v-for="(item, index) in userForm.userImgList" :key="item.id"  @click="showImg(index, userForm.userImgList)" style="cursor: pointer;">
            <el-image style="width: 40px; height: 40px;" fit="cover" :src="item.img" ><template #error><div class="el-img-error">暂无图片</div></template></el-image>
          </div>
        </el-space>
      </el-descriptions-item>
      <el-descriptions-item label-class-name="my-label" class-name="my-item" label="备注" :span="2"><UserRemark :userRemarkList="userForm.userRemarkList" /></el-descriptions-item>

    </el-descriptions>

    <el-descriptions title="总余额" border :column="2" size="small" style="margin-top: 24px;" v-if="userForm && JSON.stringify(userForm) != '{}'">
      <template #title>
        <p>总余额：<span v-if="userForm.userWallet" style="color: #3a8ee6">{{ userForm.userWallet.balanceSumAll}}<span class="giveFont" v-if="userForm.userWallet.balanceSumAll">（{{userForm.userWallet.balanceSum}} + {{userForm.userWallet.balanceSumGive}}）</span></span></p>
      </template>
      <template #extra>
        <el-button type="danger" size="small" @click="openDialog">充值</el-button>
      </template>
      <div v-if="userForm.userWallet">
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="500账户">{{ userForm.userWallet.balanceSumOne}}<span class="giveFont" v-if="userForm.userWallet.balanceSumOne">（{{ userForm.userWallet.balanceOne}} + {{userForm.userWallet.balanceOneGive}}）</span></el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="1000账户">{{ userForm.userWallet.balanceSumTwo}}<span class="giveFont"  v-if="userForm.userWallet.balanceSumTwo">（{{ userForm.userWallet.balanceTwo}} + {{userForm.userWallet.balanceTwoGive}}）</span></el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="1500账户">{{ userForm.userWallet.balanceSumThree}}<span class="giveFont"  v-if="userForm.userWallet.balanceSumThree">（{{ userForm.userWallet.balanceThree}} + {{userForm.userWallet.balanceThreeGive}}）</span></el-descriptions-item>
        <el-descriptions-item label-class-name="my-label" class-name="my-item" label="2500账户">{{ userForm.userWallet.balanceSumFour}}<span class="giveFont"  v-if="userForm.userWallet.balanceSumFour">（{{ userForm.userWallet.balanceFour}} + {{userForm.userWallet.balanceFourGive}}）</span></el-descriptions-item>
      </div>

    </el-descriptions>

    <el-form ref="formRef" label-width="90px" label-position="right" style="margin-top: 24px;" v-if="userForm && JSON.stringify(userForm) != '{}'">
      <el-form-item :label="consumeForm.type == 1?'预约宠物：':'服务宠物：'">
        <div>
          <p v-for="(item, index) of petSelect" :key="item.id" style="width: 100%;">
            {{item.petBreedColorName}}{{item.woolState == 1?'短毛':item.woolState == 2?'长毛':''}}（{{item.name}}）<span v-if="item.petAgeMonth">{{item.petAgeMonth.age}}岁{{item.petAgeMonth.month}}个月</span>（{{item.sex == 1?'弟弟':item.sex == 2?'妹妹':'未知'}}）{{item.neuteringState == 1?'已绝育':item.neuteringState == 2?'未绝育':'未知'}}
            <span v-if="item.exemptionDesc" style="color: red; font-size: 12px">*{{item.exemptionDesc}}</span>
          </p>
        </div>
      </el-form-item>
      <el-form-item label="预约时间：" v-if="consumeForm.type == 1">
        <div>{{consumeForm.preDay}} {{consumeForm.preTime}}</div>
      </el-form-item>
      <el-form-item label="消费项目：">
        <div v-if="proContent" style="display: flex; align-items: center;justify-content: space-between; width: 100%">
          <p style="margin-right: 24px;">{{proContent}}</p>
          <el-button v-if="consumeForm.editState == 0 && editable" type="primary" size="small" @click="editProjectDialog(1)">编辑</el-button>
        </div>
        <el-button v-else @click="editProjectDialog(-1)" :disabled="consumeForm.editState == 1 || !editable">+ 添加</el-button>

        <div v-if="consumeForm.projectAll" style="width: 100%">
          <el-table
              ref="multipleTableRef"
              :data="consumeForm.projectAll.projectOneList"
              style="width: 100%; "
              size="small"
              border
          >
            <el-table-column property="name" label="消费项目" width="200">
              <template #default="scope">
                <span style="white-space: nowrap; text-overflow: ellipsis;">{{scope.row.name}}<span v-if="scope.row.isGive == 1">（赠送）</span></span>
              </template>
            </el-table-column>
            <el-table-column property="petName" label="服务宠物" />
            <el-table-column property="amount" label="张数/数量" >
              <template #default="scope">
                <span v-if="(scope.row.projectType == 1 && scope.row.projectServiceType != 3) || (scope.row.projectId == 0 && scope.row.commodityId == 0 && scope.row.projectServiceType == 3)">1</span>
                <span v-else>{{scope.row.amount}}</span>
              </template>
            </el-table-column>
            <el-table-column property="originalPrice" label="原价" />
            <el-table-column property="discountNUm" label="会员优惠" >
              <template #default="scope">
                <p v-if="scope.row.discountNUm > 0" style="color: red">-{{scope.row.discountNUm}}</p>
              </template>
            </el-table-column>
            <el-table-column property="extraNUm" label="额外优惠" >
              <template #default="scope">
                <p v-if="scope.row.extraNUm > 0" style="color: red">-{{scope.row.extraNUm}}</p>
              </template>
            </el-table-column>
            <el-table-column property="firstDiscountNum" label="初步优惠后合计"  width="110" />
            <el-table-column property="giveNum" label="赠送金额" v-if="consumeForm.paymentDetail" >
              <template #default="scope">
                <p v-if="scope.row.giveNum > 0" style="color: red">-{{scope.row.giveNum}}</p>
              </template>
            </el-table-column>
            <el-table-column property="afterDiscountNum" label="总优惠后合计" width="110" v-if="consumeForm.paymentDetail" />
            <el-table-column property="operateAdminName" label="负责人" />
            <el-table-column property="visitDay" label="回访天数" >
              <template #default="scope">
                {{scope.row.visitDay == -1?'无需回访':scope.row.visitDay == 0?'立即回访':scope.row.visitDay}}
              </template>
            </el-table-column>
          </el-table>
        </div>

      </el-form-item>
      <el-form-item label="支付记录：">
        <div v-if="payContent" style="display: flex; align-items: center;justify-content: space-between; width: 100%">
          <p style="margin-right: 24px;">{{payContent}}</p>
          <el-button v-if="consumeForm.editState == 0 && editable" type="primary" size="small" @click="editPaymentDialog(1)">编辑</el-button>
        </div>
        <el-button v-else @click="editPaymentDialog(-1)" :disabled="consumeForm.editState == 1 || !editable">+ 添加</el-button>
      </el-form-item>
    </el-form>
    <div v-if="!editable" style="color: red; font-size: 12px">*当前角色没有该门店的编辑权限</div>
    <div v-else>
      <p v-if="consumeForm.editState == 1" style="color: red; font-size: 12px">*三天后无法修改</p>
    </div>
    <div class="dialog-footer" style="text-align: center; margin-top: 8px;" v-if="userForm && JSON.stringify(userForm) != '{}'">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>
</template>

<script>
import Dialog from "@/assets/js/dialog";
import EditPaymentDialog from "@/views/user/components/payment/EditPaymentDialog";
import Drawer from "@/assets/js/drawer";
import EditProjectDialog from "@/views/user/components/project/EditProjectDialog";
import UserRemark from "@/components/Remark/UserRemark";
import {getConsumeInfo, getUserInfo} from "@/api/url";
import { getFormData } from "@/api/api";
import ImgViewer from "@/assets/js/imageViewer";
import UserDialog from "@/views/user/components/UserDialog";
import UserListDialog from "@/views/preBook/components/UserListDialog";
import {add, Number_SubAll} from "@/assets/shared/util";
import payListDialog from "@/views/user/components/payListDialog";
import PayDeductionListDialog from "@/views/user/components/PayDeductionListDialog";

export default {
  name: "PayDetailDialog",
  components: { UserRemark },
  props: {
    value: Object
  },
  data() {
    return {
      idx: this.value.idx,
      shopId: this.value.shopId,
      shopName: '',
      userForm: this.value.userForm,
      consumeId: this.value.consumeId,
      consumeForm: {},
      // petList: [],
      preBookPetList: [],
      petSelect: [],

      proContent: '',
      payContent: '',

      editable: true,

      showAddBtn: this.value.showAddBtn,

    }
  },

  computed: {
    // editable() {
    //   let state = true
    //   let visibleShopList = JSON.parse(sessionStorage.getItem('visibleShopList'))
    //   if(visibleShopList.every(item => item.id != this.shopId)) {
    //     state = false
    //   }
    //   return state
    // }
  },

  methods: {

    showImg(idx, list) {
      let imgList = []
      for(let i=0; i<list.length; i++) {
        imgList.push(list[i].img)
      }
      ImgViewer.open({
        imgList: imgList,
        imgIndex: idx
      })
    },

    isEditAble() {
        this.editable = true
        let visibleShopList = JSON.parse(sessionStorage.getItem('ownShopList')).filter(item => item.isEdit == 1)
        if(visibleShopList.every(item => item.id != this.shopId)) {
          this.editable = false
        }
    },

    cancel() {
      this.$emit("confirm");
    },

    summit() {
      this.$emit("confirm");
    },

    getConsume(id) {
      getFormData(getConsumeInfo, {id: id}).then(data => {
          this.consumeForm = data.data
          this.shopId = data.data.preBookShop.id
          this.shopName = data.data.preBookShop.name
          this.preBookPetList = data.data.preBookPetList
          this.petSelect = []
          for(let i=0; i<this.preBookPetList.length; i++) {
            for(let j=0; j<this.userForm.petList.length; j++) {
              if(this.preBookPetList[i].petId == this.userForm.petList[j].id) {
                this.petSelect.push(this.userForm.petList[j])
              }
            }
          }
        if(this.consumeForm.projectAll) {
          this.proContent = data.data.projectAll.contentTotal
          this.consumeForm.projectAll.projectOneList.map(item => {
            item.discountNUm = 0 //会员优惠
            item.extraNUm = 0  //额外优惠
            item.firstDiscountNum = 0  //初步优惠后价格
            item.giveNum = 0  //赠送金额
            item.afterDiscountNum = 0 //总优惠后合计

            if(item.price <= item.discountPrice) {
              item.discountNUm = Number_SubAll(item.originalPrice, item.discountPrice)
              item.extraNUm = Number_SubAll(item.discountPrice, item.price)
              item.firstDiscountNum = Number_SubAll(item.originalPrice, add([item.discountNUm, item.extraNUm]))
            }else {
              item.extraNUm = Number_SubAll(item.originalPrice, item.price)
              item.firstDiscountNum = item.price
            }
            if(this.consumeForm.paymentDetail) {
              item.giveNum = ((this.consumeForm.paymentDetail.giveDeduction * item.price)/this.consumeForm.projectAll.totalMoney).toFixed(2)
              item.afterDiscountNum = Number_SubAll(item.firstDiscountNum, item.giveNum)
            }
          })
        }
        if(this.consumeForm.paymentDetail) {
          this.payContent = data.data.paymentDetail.content
        }
        this.isEditAble()
      })
    },

    // add() {
    //   let proDetailForm = {};
    //   Drawer.open({
    //     title: '添加消费项目',
    //     component: EditProjectDialog,
    //     data: {
    //       userForm: this.userForm,
    //       // userId: this.userForm.id,
    //       idx: -1,
    //       proDetailForm: proDetailForm,
    //       checkList: this.userForm.petIdList,
    //       width: 1000
    //     },
    //     confirm: (result) => {
    //       this.getPage();
    //       sessionStorage.setItem('recordState', JSON.stringify(true))
    //     }
    //   })
    // },

    editProjectDialog(idx) {
      let _title = ''
      let proDetailForm = {}
      if(idx > -1) {
        _title = '编辑消费项目'
        proDetailForm = this.consumeForm.projectAll
      } else {
        _title = '添加消费项目'
      }
      Drawer.open({
        title: _title,
        component: EditProjectDialog,
        data: {
          userForm: this.userForm,
          // userId: this.userForm.id,
          idx: idx,
          preBookId: this.consumeId,
          shopId: this.userForm.type == 1?this.userForm.shopId:this.shopId,
          shopName: this.userForm.type == 1?this.userForm.shopName:this.shopName,
          proDetailForm: proDetailForm,
          // checkList: this.petIdList,
          preBookPetList: this.preBookPetList,
          petList: this.userForm.petList,
          type: this.consumeForm.type?this.consumeForm.type:0,
          width: 1200
        },
        confirm: (result) => {
          // this.$emit("confirm");
          this.consumeId = result
          this.getConsume(result)
          this.getUserInfo(this.userForm.id)
        }
      })
    },

    editPaymentDialog(idx) {
      let _title = ''
      let payDetailForm = {}
      if(idx > -1) {
        _title = '编辑支付记录'
        payDetailForm = this.consumeForm.paymentDetail
      } else {
        _title = '添加支付记录'
      }
      Drawer.open({
        title: _title,
        component: EditPaymentDialog,
        data: {
          userForm: this.userForm,
          // userId: this.userForm.id,
          idx: idx,
          preBookId: this.consumeId,
          shopId: this.userForm.type == 1?this.userForm.shopId:this.shopId,
          shopName: this.userForm.type == 1?this.userForm.shopName:this.shopName,
          payDetailForm: payDetailForm,
          // checkList: this.petIdList,
          preBookPetList: this.preBookPetList,
          petList: this.userForm.petList,
          type: this.consumeForm.type?this.consumeForm.type:0,
          width: 1000,
          proContent: this.proContent,
          totalMoney: this.consumeForm.projectAll?this.consumeForm.projectAll.totalMoney:0
        },
        confirm: (result) => {
          // this.$emit("confirm");
          this.consumeId = result
          this.getConsume(result)
          this.getUserInfo(this.userForm.id)
        }
      })
    },

    getUserInfo(id) {
      getFormData(getUserInfo, {id: id}).then(data => {
        this.userForm = data.data
        this.userForm.userWallet.balanceSum = add([this.userForm.userWallet.balanceOne, this.userForm.userWallet.balanceTwo, this.userForm.userWallet.balanceThree, this.userForm.userWallet.balanceFour])
        this.userForm.userWallet.balanceSumGive = add([this.userForm.userWallet.balanceOneGive, this.userForm.userWallet.balanceTwoGive, this.userForm.userWallet.balanceThreeGive, this.userForm.userWallet.balanceFourGive])
        this.userForm.userWallet.balanceSumAll = add([this.userForm.userWallet.balanceSum, this.userForm.userWallet.balanceSumGive])
        this.userForm.userWallet.balanceSumOne = add([this.userForm.userWallet.balanceOne, this.userForm.userWallet.balanceOneGive])
        this.userForm.userWallet.balanceSumTwo = add([this.userForm.userWallet.balanceTwo, this.userForm.userWallet.balanceTwoGive])
        this.userForm.userWallet.balanceSumThree = add([this.userForm.userWallet.balanceThree, this.userForm.userWallet.balanceThreeGive])
        this.userForm.userWallet.balanceSumFour = add([this.userForm.userWallet.balanceFour, this.userForm.userWallet.balanceFourGive])
      })
    },

    openDialog() {
      Dialog.open({
        title: '充值抵扣记录',
        component: PayDeductionListDialog,
        data: {
          id: this.userForm.id,
          userForm: this.userForm,
          width: '1100px'
        },
        close: () => {
          if(JSON.parse(sessionStorage.getItem('recordState'))) {
            this.getUserInfo(this.userForm.id)
          }
          sessionStorage.removeItem('recordState')
        }
      })
    },

    editUserDialog() {
      let _title = '创建新客';
      let userForm = {}
      Dialog.open({
        title: _title,
        component: UserDialog,
        data: {
          userForm: userForm,
          ids: -2,
          width: '600px',
        },
        confirm: (result) => {
          this.getUserInfo(result)
        }
      })
    },

    selectUser() {
      Drawer.open({
        title: '客户列表',
        component: UserListDialog,
        data: {
          shopId: this.shopId,
          width: 600
        },
        confirm: (result) => {
          this.getUserInfo(result.id)
        }
      })
    },

    // editPaymentDialog(tradeNo) {
    //   Drawer.open({
    //     title: '支付编号：' + tradeNo,
    //     component: EditPaymentDialog,
    //     data: {
    //       userForm: this.userForm,
    //       // userId: this.userForm.id,
    //       idx: 1,
    //       preBookId: this.payDetailForm.preBookId,
    //       payDetailForm: this.payDetailForm,
    //       checkList: this.payDetailForm.petIdList,
    //       width: 800,
    //       proContent: this.payDetailForm.projectAllDesc
    //     },
    //     confirm: (result) => {
    //       this.$emit("confirm");
    //     }
    //   })
    // }

  },

  mounted() {
    if(this.idx > -1) {
      this.getConsume(this.consumeId)
    }
    if(this.userForm && JSON.stringify(this.userForm) != '{}') {
      this.getUserInfo(this.userForm.id)
    }


  },
}
</script>

<style scoped>

</style>
